module.exports = __webpack_public_path__ + "web.config";


//////////////////
// WEBPACK FOOTER
// ./src/web.config
// module id = 9z3D
// module chunks = 7